import VueRouter from 'vue-router';
import Login from '../pages/Login';
import Signup from '../pages/Signup';
import Dashboard from '../pages/Dashboard';
import EditUser from '../pages/EditUser';
import EditInstitute from '../pages/EditInstitute';
import Listings from '../pages/Listings';
import Events from '../pages/Events';
import Users from '../pages/Users';
import Reports from '../pages/Reports';
import EditListing from '../pages/EditListing';
import Mediums from '../pages/Mediums';
import Eras from '../pages/Eras';
import Artists from '../pages/Artists';
import Museums from '../pages/Museums';
import Members from '../pages/Members';
import Admins from '../pages/Admins';
import Legal from '../pages/Legal';

// Middlewares
import auth from '../middleware/auth.middleware';
import superAdmin from '../middleware/superAdmin.middleware';
import paid from '../middleware/paid.middleware';

import isSuperAdmin from '../services/jwt/isSuperAdmin';

const router = new VueRouter({
 
  routes: [
    {
		path: '/',
		redirect: {
			name: 'Dashboard'
		},
	},
    {
		path: '/login',
		name: 'Login',
		component: Login,
		meta: {
			title: "Welcome to the Museo Portal"
		}
	},
	{
		path: '/sign-up/:token?',
		name: 'Signup',
		component: Signup,
		meta: {
			title: "Welcome to the Museo Portal"
		}
    },
    {
		path: '/dashboard',
		name: 'Dashboard',
		component: Dashboard,
		meta: {
			middleware: [auth, paid],
			title: isSuperAdmin(localStorage.getItem('superAdmin')) === true ? "Museo Admin Portal" : "Museo Curator Portal"
		}
	},
	{
		path: '/edit-user/:notPaid?',
		name: 'EditUser',
		component: EditUser,
		meta: {
			middleware: auth,
			title: isSuperAdmin(localStorage.getItem('superAdmin')) === true ? "Museo Admin Portal" : "Museo Curator Portal"
		}
	},
	{
		path: '/edit-institute',
		name: 'EditInstitute',
		component: EditInstitute,
		meta: {
			middleware: [ auth, paid ],
			title: isSuperAdmin(localStorage.getItem('superAdmin')) === true ? "Museo Admin Portal" : "Museo Curator Portal"
		}
	},
	{
		path: '/listings/:review?',
		name: 'Listings',
		component: Listings,
		meta: {
			middleware: [ auth, paid ],
			title: isSuperAdmin(localStorage.getItem('superAdmin')) === true ? "Museo Admin Portal" : "Museo Curator Portal"
		}
	},
	{
		path: '/edit-listing/:listingID',
		name: 'EditListing',
		component: EditListing,
		meta: {
			middleware: [ auth, paid ],
			title: isSuperAdmin(localStorage.getItem('superAdmin')) === true ? "Museo Admin Portal" : "Museo Curator Portal"
		}
	},
	{
		path: '/events',
		name: 'Events',
		component: Events,
		meta: {
			middleware: [ auth, paid ],
			title: isSuperAdmin(localStorage.getItem('superAdmin')) === true ? "Museo Admin Portal" : "Museo Curator Portal"
		}
	},
	{
		path: '/users',
		name: 'Users',
		component: Users,
		meta: {
			middleware: [ auth, superAdmin ],
			title: isSuperAdmin(localStorage.getItem('superAdmin')) === true ? "Museo Admin Portal" : "Museo Curator Portal"
		}
	},
	{
		path: '/reports',
		name: 'Reports',
		component: Reports,
		meta: {
			middleware: [ auth, paid ],
			title: isSuperAdmin(localStorage.getItem('superAdmin')) === true ? "Museo Admin Portal" : "Museo Curator Portal"
		}
	},
	{
		path: '/mediums',
		name: 'Mediums',
		component: Mediums,
		meta: {
			middleware: [ auth, superAdmin ],
			title: "Museo Admin Portal"
		}
	},
	{
		path: '/institutes',
		name: 'Museums',
		component: Museums,
		meta: {
			middleware: [ auth, superAdmin ],
			title: "Museo Admin Portal"
		}
	},
	{
		path: '/eras',
		name: 'Eras',
		component: Eras,
		meta: {
			middleware: [ auth, superAdmin ],
			title: "Museo Admin Portal"
		}
	},
	{
		path: '/members',
		name: 'Members',
		component: Members,
		meta: {
			middleware: [ auth, superAdmin ],
			title: "Museo Admin Portal"
		}
	},
	{
		path: '/artists',
		name: 'artists',
		component: Artists,
		meta: {
			middleware: [ auth, superAdmin ],
			title: "Museo Admin Portal"
		}
	},
	{
		path: '/admins',
		name: 'admins',
		component: Admins,
		meta: {
			middleware: [ auth, superAdmin ],
			title: "Museo Admin Portal"
		}
	},
	{
		path: '/legal',
		name: 'legal',
		component: Legal,
		meta: {
			middleware: [ auth, superAdmin ],
			title: "Museo Admin Portal"
		}
	}

  ],
  mode: 'history'
});


function nextFactory(context, middleware, index) {
    const subsequentMiddleware = middleware[index];

    if (!subsequentMiddleware) {
		return context.next;
    } 
  
    return (...parameters) => {
		context.next(...parameters);
		const nextMiddleware = nextFactory(context, middleware, index + 1);
		subsequentMiddleware({ ...context, next: nextMiddleware });
    };
}
  
router.beforeEach((to, from, next) => {
	document.title = to.meta.title

	if (to.meta.middleware) {
		const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware];

		const context = {
			from,
			next,
			router,
			to,
		};
		const nextMiddleware = nextFactory(context, middleware, 1);

		return middleware[0]({ ...context, next: nextMiddleware });
	}

	return next();
});

export default router;